import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "section-title" }
const _hoisted_2 = {
  key: 1,
  class: "table-wrapper"
}
const _hoisted_3 = {
  key: 2,
  class: "table-wrapper"
}

import dayjs from 'dayjs'
import { reactive, computed } from 'vue'

import { TripExtended, TripExtra, TripPaymentKapital } from '@/models/trip'
import { useTripsStore } from '@/store/trips'

import FinishTripPayment from './FinishTripPayment.vue'
import { RbacAction, RbacEntity } from '@/helpers/rbac'
import useScopeCheck from '@/composables/useScopeCheck'
import { watchEffect } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FinanceSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const allowedEdit = useScopeCheck(RbacAction.UPDATE, RbacEntity.WALLET)

const tripsStore = useTripsStore()
// "🚀 ~ tripsStore:", tripsStore)

const props = __props

watchEffect(() => {
  // props.trip.payment);
})

const tripExtra = reactive<Partial<TripExtra>>({
  odometer_before: props.trip.extra?.odometer_before,
  odometer_after: props.trip.extra?.odometer_after,
})

// Check if kapital transactions have data
const hasKapitalTransactions = computed(() => {
  return (
    props.trip.kapital_transactions &&
    props.trip.kapital_transactions.length > 0
  )
})

// Check if credit card operations have any non-zero data
const hasCreditCardData = computed(() => {
  // For kapital installment trips
  if (props.trip.trip_payments_kapital && props.trip.taksit !== null) {
    const kapital = props.trip.trip_payments_kapital
    return (
      (kapital.total_freeze || 0) > 0 ||
      (kapital.total_charge || 0) > 0 ||
      (kapital.total_reverse || 0) > 0
    )
  }
  // For regular trips with payment data
  const payment = props.trip.payment
  if (!payment) return false
  return (
    (payment.deposit_freeze || 0) > 0 ||
    (payment.deposit_charge || 0) > 0 ||
    (payment.deposit_reverse || 0) > 0 ||
    (payment.service_freeze || 0) > 0 ||
    (payment.service_charge || 0) > 0 ||
    (payment.service_reverse || 0) > 0
  )
})

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_descriptions, {
      title: "Financial info",
      direction: "vertical",
      class: "data-description",
      column: 3,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, { label: "Total Bill" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trip.total / 100), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Promotional Admin Fee Accepted" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(Boolean(_ctx.trip?.is_promotional_admin_fee)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Cancellation Policy Choice" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trip.cancellation_policy_type), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Odometer" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              gutter: 12,
              align: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  md: 12,
                  lg: 10
                }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createTextVNode(" Before ")),
                    _createVNode(_component_el_input_number, {
                      min: 0,
                      step: 10,
                      modelValue: tripExtra.odometer_before,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tripExtra.odometer_before) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1,
                  __: [3]
                }),
                _createVNode(_component_el_col, {
                  span: 24,
                  md: 12,
                  lg: 10
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createTextVNode(" After ")),
                    _createVNode(_component_el_input_number, {
                      min: 0,
                      step: 10,
                      modelValue: tripExtra.odometer_after,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tripExtra.odometer_after) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1,
                  __: [4]
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  lg: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(tripsStore).updateTripExta(_ctx.trip.id, tripExtra)))
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" Save ")
                      ])),
                      _: 1,
                      __: [5]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Charge ([₼ / km])" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trip.extra_distance_charge != null
          ? _ctx.trip.extra_distance_charge / 100
          : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Odometer limit" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trip.extra?.odometer_limit ?? '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Actually traveled" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trip.extra?.actual_traveled ?? '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Extra charge" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trip.extra?.extra_charge ?? '-'), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (hasCreditCardData.value)
      ? (_openBlock(), _createBlock(_component_el_descriptions, {
          key: 0,
          title: "Credit card operations",
          direction: "vertical",
          class: "data-description",
          column: 3,
          border: ""
        }, {
          default: _withCtx(() => [
            (_ctx.trip.trip_payments_kapital && _ctx.trip.taksit !== null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_descriptions_item, { label: "Total Frozen" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.trip.trip_payments_kapital.total_freeze / 100), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Charged" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.trip.trip_payments_kapital.total_charge / 100), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Refunded" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.trip.trip_payments_kapital.total_reverse / 100), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_descriptions_item, { label: "Frozen amount" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.trip.payment?.deposit_freeze ?? 0) / 100), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Charged Amount" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.trip.payment?.deposit_charge ?? 0) / 100), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Refunded Amount" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.trip.payment?.deposit_reverse ?? 0) / 100), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Frozen amount (service)" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.trip.payment?.service_freeze ?? 0) / 100), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Charged Amount (service)" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.trip.payment?.service_charge ?? 0) / 100), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Refunded Amount (service)" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.trip.payment?.service_reverse ?? 0) / 100), 1)
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_1, _toDisplayString(hasKapitalTransactions.value ? 'Kapital Bank Transactions:' : 'Transactions:'), 1),
    (hasKapitalTransactions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_table, {
            "table-layout": "auto",
            "row-key": "id",
            "class-name": "transactions",
            data: _ctx.trip.kapital_transactions,
            "show-header": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { type: "expand" }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_timeline, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.logs, (log) => {
                        return (_openBlock(), _createBlock(_component_el_timeline_item, {
                          key: log.id,
                          timestamp: _unref(dayjs)(log.createdAt).format('lll')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_descriptions, {
                              direction: "vertical",
                              column: 4,
                              border: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_descriptions_item, {
                                  width: "40%",
                                  label: "Status"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(log.status), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_descriptions_item, {
                                  width: "30%",
                                  label: "Request Data"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(log.request_data), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_descriptions_item, {
                                  width: "30%",
                                  label: "Response Data"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(log.response_data), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["timestamp"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Date created",
                width: "200"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(dayjs)(row.createdAt).format('lll')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Order ID",
                prop: "order_id",
                width: "100"
              }),
              _createVNode(_component_el_table_column, { width: "775" }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_table, {
                      data: [row],
                      style: { margin: '0' },
                      size: "small",
                      "header-cell-style": {
                  fontSize: '11px',
                  padding: '4px',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                },
                      "cell-style": {
                  fontSize: '11px',
                  padding: '4px',
                  whiteSpace: 'nowrap',
                }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          width: "80",
                          label: "Action",
                          prop: "action"
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "120",
                          label: "Amount"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString((row.amount ?? 0) / 100), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_table_column, {
                          width: "85",
                          label: "Currency",
                          prop: "currency_code"
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "70",
                          label: "Type",
                          prop: "type"
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "100",
                          label: "Payriff Type",
                          prop: "payriff_type"
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "100",
                          label: "Order Status",
                          prop: "order_status"
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "140",
                          label: "Gateway Response",
                          prop: "gateway_response"
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "70",
                          label: "Taksit",
                          prop: "taksit"
                        })
                      ]),
                      _: 2
                    }, 1032, ["data"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Internal comment",
                prop: "internal_comment"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]))
      : (_ctx.trip.transactions && _ctx.trip.transactions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_table, {
              "table-layout": "auto",
              "row-key": "id",
              "class-name": "transactions",
              data: _ctx.trip.transactions,
              "show-header": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { type: "expand" }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_timeline, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.logs, (log) => {
                          return (_openBlock(), _createBlock(_component_el_timeline_item, {
                            key: log.id,
                            timestamp: _unref(dayjs)(log.created_at).format('lll')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_descriptions, {
                                direction: "vertical",
                                column: 4,
                                border: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_descriptions_item, {
                                    width: "55%",
                                    label: "Comment"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(log.comment), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_descriptions_item, {
                                    width: "15%",
                                    label: "Status"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(log.transaction_status), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_descriptions_item, {
                                    width: "15%",
                                    label: "Yigim type"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(log.payriff_type), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_descriptions_item, {
                                    width: "15%",
                                    label: "Amount"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(log.amount / 100), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["timestamp"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "Date created" }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(dayjs)(row.created_at).format('lll')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Order ID",
                  prop: "order_id"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Order Description",
                  prop: "description"
                }),
                _createVNode(_component_el_table_column, null, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_descriptions, {
                      direction: "vertical",
                      column: 2,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_descriptions_item, { label: "Action" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.action), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_descriptions_item, { label: "Amount" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.amount / 100), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_descriptions_item, { label: "Gateway response" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.gateway_response), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Internal comment",
                  prop: "internal_comment"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
    (_unref(allowedEdit))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "section-title" }, " Finish payment: ", -1)),
          _createVNode(FinishTripPayment, { trip: _ctx.trip }, null, 8, ["trip"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})